import { a as o_global } from "../chunks/common-namespaces-client-C7k75bsz.mjs";
const events = o_global.events;
const eventQBus = o_global.eventQBus;
export {
  eventQBus,
  events
};
/*                                           */
